import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Store } from "../states/store";

function Private({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const token = Store.getState().auths.token;

  // if (!token) return <Navigate to="/login" state={{ from: location }} />;
  return <div>{children}</div>;
}

export default Private;
